import { render, staticRenderFns } from "./LA.vue?vue&type=template&id=0d1147a4&scoped=true&"
import script from "./LA.vue?vue&type=script&lang=js&"
export * from "./LA.vue?vue&type=script&lang=js&"
import style0 from "./LA.vue?vue&type=style&index=0&id=0d1147a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1147a4",
  null
  
)

export default component.exports